import { newE2EPage } from "@stencil/core/testing";

describe("uic-scroll-picker", () => {
    it("renders", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-scroll-picker></uic-scroll-picker>`);

        const items = [...Array(60).keys()].map((x) => {
            x++;
            return {
                text: `${x}`,
                value: x,
            };
        });

        const el = (await page.find("uic-scroll-picker")) as any;
        el.setProperty("items", items);
        el.setProperty("value", 30);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });
});
